import React, { useState } from "react";
import menu from "assets/icons/menu.svg";
import close from "assets/icons/close.svg";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Link,
} from "react-router-dom";
import styles from "./style.module.scss";
import { icons, images } from "assets";
import * as componentIcons from "assets/svgComponents";
import {
  HIDE_BALANCE,
  SHOW_BALANCE,
  useBalanceDispatch,
  useBalanceStore,
} from "providers/balance";

const MobileSideBar = () => {
  const [menuButton, setMenu] = useState(false);
  const { showBalance } = useBalanceStore();

  const balDispatch = useBalanceDispatch();

  const handleClick = () => {
    setMenu(!menuButton);
  };

  return (
    <div className={styles.header}>
      <div>
        <Link to="/">
          <img src={icons.logo2} style={{ width: "82%" }} alt="Logo" />
        </Link>
      </div>
      <div
        className={styles["header-icon"]}
        style={{ display: "flex", alignItems: "center", gap: "1rem" }}
      >
        <div
          onClick={() =>
            balDispatch({ type: showBalance ? HIDE_BALANCE : SHOW_BALANCE })
          }
        >
          <img src={showBalance ? icons.eye_close : icons.open_eye} alt="HIDEN"  width={18}/>
        </div>
        <div>
          <img
            src={images.profileImage}
            alt="Menu"
            style={{ width: "30px", height: "30px" }}
          />
        </div>
        <div onClick={handleClick}>
          <img src={menu} alt="Menu" style={{ width: "30px" }} />
        </div>
      </div>
      <div
        className={
          menuButton
            ? `${styles["mobile-menu"]} ${styles["actives"]}`
            : styles["mobile-menu"]
        }
      >
        <div
          className={styles.close}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "2rem",
          }}
        >
          <img
            src={icons.logo2}
            alt="CLOSE"
            onClick={handleClick}
            style={{ width: "70%" }}
          />
          <img
            src={close}
            alt="CLOSE"
            onClick={handleClick}
            style={{ width: "10%" }}
          />
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.dashboard}
              alt="CLOSE"
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>Dashboard</p>
          </NavLink>
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/wallet"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.wallet}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>Wallet</p>
          </NavLink>
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/debit-card"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.debit_card}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>Debit Card</p>
          </NavLink>
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/transfer"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.transfer}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>International Transfer</p>
          </NavLink>
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/transaction-history"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.tran_history}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>Transaction History</p>
          </NavLink>
        </div>
        <div onClick={handleClick}>
          <NavLink
            to="/account"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.account}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p>Account</p>
          </NavLink>
        </div>
        <div onClick={handleClick} className="bottom">
          <NavLink
            to="/logout"
            activeclassName={styles.active}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={icons.logout}
              alt="CLOSE"
              onClick={handleClick}
              style={{ height: "15px", paddingLeft: "1.5rem" }}
            />
            <p style={{ color: "black" }}>Logout</p>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default MobileSideBar;

// .Logout{
//   position: absolute ;
//   bottom: 41px;
//   left: 27px;
//   stroke: var(--primary-text);
// }
